import {basicSetup, EditorView} from "codemirror"
import {javascript} from "@codemirror/lang-javascript"
import {placeholder} from "@codemirror/view";

function toggleTextArea(textarea: HTMLTextAreaElement, visible: boolean) {
	textarea.style.display = visible ? '' : "none";
}

function editorFromTextArea(textarea: HTMLTextAreaElement, extensions: any[]) {
	let initialValue = textarea.value;
	/*
		const minRows = textarea.rows;
		if (Number.isFinite(minRows)) {
			const rows = Math.max(1, minRows);
			if (initialValue.trim().length == 0) {
				initialValue = "\n".repeat(rows);
			}
		}
	*/

	const extensionsFull = [
		...extensions,
		EditorView.updateListener.of(function (e) {
			if (e.docChanged) {
				textarea.value = e.state.doc.toString();
			}
		})
	]

	let view = new EditorView({doc: initialValue, extensions: extensionsFull})

	textarea.parentNode!!.insertBefore(view.dom, textarea)
	toggleTextArea(textarea, false);

	return view
}

export class JavascriptEditor {
	constructor(textarea: string | HTMLTextAreaElement) {
		if (typeof textarea === 'string') {
			document.querySelectorAll<HTMLTextAreaElement>(textarea).forEach(node => {
				this.configureEditor(node);
			})

		} else {
			this.configureEditor(textarea)
		}
	}

	private configureEditor(textarea: HTMLTextAreaElement) {
		editorFromTextArea(textarea, [
			placeholder(textarea.placeholder),
			basicSetup,
			javascript(),
		]);
	}
}
